module.exports = __webpack_public_path__ + "static/20230619_042-631c18a11ba2c47c5c977224296196e9.jpg";